/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_Th_ShareInputs */

const vi_movement_breakdown_th_share = /** @type {(inputs: Movement_Breakdown_Th_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tỷ trọng`)
};

/**

* @param {Movement_Breakdown_Th_ShareInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_th_share = /** @type {((inputs?: Movement_Breakdown_Th_ShareInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_Th_ShareInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_th_share(inputs)
});